import { render, staticRenderFns } from "./CustomerFiles.vue?vue&type=template&id=c7378de8&scoped=true"
import script from "./CustomerFiles.vue?vue&type=script&lang=js"
export * from "./CustomerFiles.vue?vue&type=script&lang=js"
import style0 from "./CustomerFiles.vue?vue&type=style&index=0&id=c7378de8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7378de8",
  null
  
)

export default component.exports